/**
 * Basic Auth Connector Component
 * Form component for basic authentication configuration
 */

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { UseFormReturn } from 'react-hook-form'

interface BasicAuthConnectorProps {
  form: UseFormReturn<any>
}

/**
 * Basic Auth connector form component
 */
export function BasicAuthConnector({ form }: BasicAuthConnectorProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="username"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Username</FormLabel>
            <FormMessage />
            <FormControl>
              <Input
                value={field.value ?? ""}
                placeholder="Username for authenticating"
                {...form.register("username", {
                  required: true,
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="password"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Password</FormLabel>
            <FormMessage />
            <FormControl>
              <Input
                value={field.value ?? ""}
                placeholder="Password for authenticating"
                {...form.register("password", {
                  required: true,
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  )
}